import { KuxErrorType, KuxFilteredCategoriesDTO } from '@kaltura-ott/tvpil';

import { convertKalturaAssetToTvpil } from '../../../../../rhino';
import { fetchSearchResults } from '../../../../../rhino';
import { errorHandling } from '../../../../../utils/error-handling';
import { CardPlaceholder, EntitiesType } from '../../../../entities';

import { CollectionRailStoreV2 } from './collection-rail-store-v2';

export class SearchRailStore extends CollectionRailStoreV2 {
  private errorHandler?: (error?: KuxErrorType) => void;
  private groupByPolicy?: object;
  private groupByRepresentativePolicy?: object;
  private groupByUnmatchedItemsPolicy?: object;
  private orderByPolicy?: object;
  public isGroupByEnabled = false;

  constructor(
    categoryTree: KuxFilteredCategoriesDTO,
    parentCategoryTree: KuxFilteredCategoriesDTO,
    children?: [],
    handleAssetListErrors?: boolean,
    errorHandler?: (error?: KuxErrorType) => void,
  ) {
    super(categoryTree, parentCategoryTree, children, handleAssetListErrors);
    this.errorHandler = errorHandler;

    this.isGroupByEnabled = categoryTree.searchProperty.isGroupByEnabled;
    this.groupByPolicy = this.tryParseSearchProperty('GroupByObject', categoryTree.searchProperty.groupBy);
    this.groupByRepresentativePolicy = this.tryParseSearchProperty(
      'GroupByRepresentativePolicyObject',
      categoryTree.searchProperty.groupByRepresentativePolicy,
    );
    this.groupByUnmatchedItemsPolicy = this.tryParseSearchProperty(
      'GroupByUnmatchedItemsPolicy',
      categoryTree.searchProperty.groupByUnmatchedItemsPolicy,
    );
    this.orderByPolicy = this.tryParseSearchProperty('OderByPolicyObject', categoryTree.searchProperty.orderByPolicy);
  }

  private tryParseSearchProperty(displayTitle: string, value?: string) {
    if (!value) {
      return;
    }

    try {
      return JSON.parse(value);
    } catch (e) {
      console.log(`Unable to parse Search.${displayTitle}`);
    }
  }

  @errorHandling({
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: function (this: SearchRailStore, error: any) {
      this.errorHandlerCallback(error);
    },
  })
  protected async getData(
    pageIndex: number,
    items: (EntitiesType | CardPlaceholder)[],
  ): Promise<{ items: (EntitiesType | CardPlaceholder)[]; totalCount: number; newItems: EntitiesType[] }> {
    const adultCategoryReferenceId = this.transactionStore.isAdultEntitled
      ? undefined
      : this.dmsStore.dms.adultsConfigurations?.categoryReferenceId;

    const collectionFilteringKsql = this.categoryTree.searchProperty.collectionFilteringKsql;

    const { objects, totalCount } = await fetchSearchResults({
      adultCategoryReferenceId,
      collectionFilteringKsql,
      collectionId: this.channels[0],
      isGroupByEnabled: this.isGroupByEnabled,
      groupBy: this.groupBy,
      groupByPolicy: this.groupByPolicy,
      groupByRepresentativePolicy: this.groupByRepresentativePolicy,
      groupByUnmatchedItemsPolicy: this.groupByUnmatchedItemsPolicy,
      kSql: this.aggregatedKSQL,
      orderBy: this.orderBy,
      orderByPolicy: this.orderByPolicy,
      pageIndex,
      pageSize: 20,
      referenceId: this.categoryTree.referenceId,
    });

    const entities: EntitiesType[] = [];

    for (let i = 0; i < objects.length; i++) {
      const assetType = convertKalturaAssetToTvpil(objects[i], { isGroupedGrid: this.isGroupByEnabled });

      if (assetType) {
        entities.push(assetType);
      }
    }

    this.innerItems.push(...entities);
    return { items: this.items, totalCount, newItems: entities };
  }

  protected errorHandlerCallback(error: KuxErrorType) {
    super.errorHandlerCallback();

    if (this.handleAssetListErrors && typeof this.errorHandler === 'function') {
      this.errorHandler(error);
    }
  }
}
